module.exports = __webpack_public_path__ + "static/media/PHOTO.546fad30.jpg";